import { useTranslation } from 'react-i18next';
import { useFilter } from './useFilter';

export default function useConversationsStatusSwitch() {
    const { t } = useTranslation('inbox');
    const [filter, setFilter] = useFilter();

    const choices = [
        { value: 'open', label: t('ConversationsStatusSwitch.open') },
        { value: 'close', label: t('ConversationsStatusSwitch.close') },
    ];

    const onChange = (status) => {
        setFilter({ status });
    };

    return { name: 'conversationsStatusName', value: filter.status, choices, onChange };
}
